import { module } from 'modujs';

//const axios = require( 'axios' ).default;
import { hide, show, toggle } from 'slidetoggle';


export default class extends module {
    constructor( m ) {
        super( m );

        this.formError = this.el.querySelector( '[data-form-error]' );
        this.formSuccess = this.el.closest( '[data-form-container]' ).querySelector( '[data-form-success]' );

        this.formLoader = this.el.querySelector( '[data-form-loader]' );
        this.fieldset = this.el.querySelector( 'fieldset' );


        this.el.addEventListener( 'submit', e => {
            e.preventDefault();

            if ( this.el.dataset.invalid ) return;



            let formData =  new FormData( this.el );
            this.disableForm();
            if( this.formLoader ){
                this.formLoader.dataset.onClasses.split( ' ' ).forEach( className => this.formLoader.classList.add( className ) );
                this.formLoader.dataset.offClasses.split( ' ' ).forEach( className => this.formLoader.classList.remove( className ) );
            }


            this.formError.classList.add( this.formError.dataset.toggleClass );
            this.formError.innerText = "";

            this.call( 'update', false, 'Scroll' );

            axios( { method : "post", url : THEME_OBJ.ajaxURL, data : formData } )
                .then( response => {

                    this.enabledForm();

                    if( this.formLoader ){
                        this.formLoader.dataset.onClasses.split( ' ' ).forEach( className => this.formLoader.classList.remove( className ) );
                        this.formLoader.dataset.offClasses.split( ' ' ).forEach( className => this.formLoader.classList.add( className ) );
                    }

                    if ( response.data.error ) {
                        this.formError.classList.remove( this.formError.dataset.toggleClass );
                        this.formError.innerText = response.data.error;

                    } else {
                        this.formError.classList.add( this.formError.dataset.toggleClass );
                        show( this.formSuccess, { miliseconds : 500 } );
                        hide( this.el, { miliseconds : 500 } );

                        setTimeout( () => {
                            this.call( 'update', false, 'Scroll' );
                            if ( response.data.redirect ) {
                                window.location = response.data.redirect;
                            }
                        }, 600 );

                    }
                } )
                .catch(  ( response ) => {

                    this.enabledForm();
                } );


        } );




    }


    enabledForm(){
        if( ! this.fieldset ) return;
        this.fieldset.classList.remove( 'wait' );
        this.fieldset.removeAttribute('disabled');
    }

    disableForm(){
        if( ! this.fieldset ) return;
        this.fieldset.classList.add( 'wait' );
        this.fieldset.setAttribute('disabled', true);
    }



    init() {
    }

    destroy() {
    }
}
